<script lang="ts" setup>
import type { Props } from './types'

defineProps<Props>()
</script>

<script lang="ts">
export default {
  name: 'AppTable'
}
</script>

<template>
  <div class="app-table w-full rounded-8 overflow-auto scrollbar-hidden">
    <div
      class="w-full table"
      :class="containerStyles">
      <div class="table-header-group">
        <slot name="header" />
      </div>

      <div class="table-row-group">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>
